module.exports = __webpack_public_path__ + "static/media/add_theme1.15b02a64.svg";